import React from 'react';
import {Space, Tabs, Card, TabsProps} from 'antd';
import {useIsDemo} from '@app/hooks/useIsDemo';
import PaymentCardForm from './PaymentCardForm';
import PaymentInvoiceForm from './PaymentInvoiceFrom';
import {usePaymentMethod} from '@app/hooks/usePaymentMethod';
import {useTranslation} from 'react-i18next';
import {EPaymentMethod} from '@app/constants';

type TFormType = 'card' | 'invoice';

const PaymentInfo: React.FC<unknown> = () => {
  const {t} = useTranslation();
  const isDemo = useIsDemo();
  const paymentMethod = usePaymentMethod();

  const renderPaymentCard = (type: TFormType) => {
    return (
      <Space direction="vertical" size={24} style={{width: '100%'}}>
        {type === 'card' && (
          <Card bordered={false}>
            <PaymentCardForm />
          </Card>
        )}
        {type === 'invoice' && (
          <Card title={t('Payment Method Invoice')} bordered={false}>
            <PaymentInvoiceForm />
          </Card>
        )}
      </Space>
    );
  };

  const forms: TabsProps['items'] = [
    {
      key: EPaymentMethod.card,
      label: t('Payment Method Card'),
      children: renderPaymentCard('card'),
      disabled: paymentMethod === EPaymentMethod.invoice,
    },
    {
      key: EPaymentMethod.invoice,
      label: t('Payment Method Invoice'),
      children: renderPaymentCard('invoice'),
      disabled: paymentMethod === EPaymentMethod.card,
    },
  ];

  return (
    <>
      <div>
        <Tabs
          type="card"
          defaultActiveKey={isDemo ? EPaymentMethod.card : paymentMethod}
          items={forms}
          tabBarGutter={5}
          tabBarStyle={{border: '1px'}}
        />
      </div>
    </>
  );
};

export default PaymentInfo;
